/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { FormWizardFooter } from "./FormWizardFooter";

type Props = React.HTMLProps<HTMLFormElement> & {
  footerProps: React.ComponentProps<typeof FormWizardFooter>;
};

export function FormWrap({ children, footerProps, ...formProps }: Props) {
  return (
    <form {...formProps}>
      <div
        css={{
          maxWidth: "924px",
          margin: "0 auto",
          paddingBottom: "3rem",
        }}
      >
        {children}
      </div>
      <FormWizardFooter {...footerProps} />
    </form>
  );
}
